/*
* Marionette LayoutView: BreadcrumbNavLayout
* -------------------------
* Representative of the breadcrumb nav bar - takes care of rendering that properly
*/

import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/breadcrumb-nav-layout.hbs';
import AccountChangeView from '@/views/account_change';
import ProductDropdownView from '@/views/product_dropdown';
import DevicegroupDropdownView from '@/views/devicegroup_dropdown';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

function show_account_dropdown(parent_view, account) {
    var primary = globalCh.request('primary_account');
    var active = globalCh.request('active_account');
    if (account) globalCh.request('setActiveAccount', account);
    var account_dropdown = new AccountChangeView({
        model: active,
        collection: primary.proxies
    });

    if ( parent_view.isDestroyed() ) return;
    parent_view.showChildView('account', account_dropdown);
}

function show_product_dropdown(parent_view, product, area, menu_action, show_pointer) {
    var products = apiCh.request('product');
    var active = product.rel.get('owner');
    products.fetch({
        data: {
            'filter[owner.id]': active.id,
        }
    })
    .always(function(resp){
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);

                if ( menu_action === undefined ) {
                    menu_action = area;
                }
                switch ( menu_action ) {
                    case 'development':
                    case 'show_development_devicegroups':
                        menu_action = 'show_development_devicegroups';
                        break;
                    case 'show_pre_production_devicegroups':
                    case 'test':
                        menu_action = 'show_pre_production_devicegroups';
                        break;
                    case 'show_pre_dut_devicegroups':
                        menu_action = 'show_pre_dut_devicegroups';
                        break;
                    case 'show_pre_factoryfixture_devicegroups':
                        menu_action = 'show_pre_factoryfixture_devicegroups';
                        break;
                    case 'show_production_devicegroups':
                    case 'production':
                        menu_action = 'show_production_devicegroups';
                        break;
                    case 'show_dut_devicegroups':
                        menu_action = 'show_dut_devicegroups';
                        break;
                    case 'show_factoryfixture_devicegroups':
                        menu_action = 'show_factoryfixture_devicegroups';
                        break;
                }
                g.menu_action = menu_action;
                list.push(g, {merge: true});
            });
        }

        var product_dropdown = new ProductDropdownView({
            collection: list,
            model: product,
            title: product && product.get('name'),
            area: area,
            menu_action: menu_action,
            show_pointer: show_pointer
        });

        parent_view.showChildView('product', product_dropdown);
        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });

}

function show_factory_dropdown(parent_view, product, area) {
    let menu_action;
    if ( area === 'production') {
        menu_action = 'show_factory_devicegroups';
    } else {
        menu_action = 'show_pre_factoryfixture_devicegroups';
    }
    show_product_dropdown(parent_view, product, area, menu_action, false);
    parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
}

function show_dut_dropdown(parent_view, product, area) {
    let menu_action;
    if ( area === 'production') {
        menu_action = 'show_dut_devicegroups';
    } else {
        menu_action = 'show_pre_dut_devicegroups';
    }
    show_product_dropdown(parent_view, product, area, menu_action, false);
    parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
}

function show_development_devicegroup_dropdown(parent_view, product, devicegroup) {
    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');
    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'development', 'show_development_devicegroups', true);
    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    })
    .always(function(resp){
        let list = new Backbone.Collection();

        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));

        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });
}

function show_pre_factoryfixture_devicegroup_dropdown(parent_view, product, devicegroup) {
    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');

    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'test', 'show_pre_factoryfixture_devicegroups', true);

    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    }).always((resp)=>{
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));
        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });
}

function show_pre_production_devicegroup_dropdown(parent_view, product, devicegroup) {
    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');

    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'test', 'show_pre_production_devicegroups', true);

    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    }).always((resp) => {
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));
        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });
}

function show_pre_dut_devicegroup_dropdown(parent_view, product, devicegroup) {
    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');
    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'test', 'show_pre_dut_devicegroups', true);

    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    }).always((resp) => {
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));
        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });
}

function show_dut_devicegroup_dropdown(parent_view, product, devicegroup) {
    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');
    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'production', 'show_dut_devicegroups', true);
    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    }).always((resp) => {
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));

        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });
}

function show_factoryfixture_dropdown(parent_view, product, devicegroup) {
    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');
    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'production', 'show_factory_devicegroups', true);

    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    }).always((resp) => {
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));
        
        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });
}

function show_devicegroup_dropdown(parent_view, product, devicegroup) {

    var devicegroups = apiCh.request(devicegroup.type);
    var active = devicegroup.rel.get('owner');
    show_account_dropdown(parent_view, active);

    show_product_dropdown(parent_view, product, 'production', 'show_production_devicegroups', true);
    devicegroups.fetch({
        data: {
            'filter[product.id]': product.id,
            'filter[type]': devicegroup.type,
            'sort': '-deployment'
        }
    }).always((resp) => {
        let list = new Backbone.Collection();
        if ( resp.data && resp.data.length && resp.data.length > 0 ) {
            resp.data.forEach(function(item){
                let g = apiCh.request(item.type, item.id);
                list.push(g, {merge: true});
            });
        }

        parent_view.showChildView('devicegroup', new DevicegroupDropdownView({
            collection: list,
            title: devicegroup && devicegroup.get('name') || 'unknown',
            active: devicegroup
        }));

        parent_view.getRegion('account').currentView.$el.find('.breadcrumb-pointer').show();
    });

}

function handle_selection(selection) {
    if ( this.isDestroyed() ) return;
    if (selection.type === 'empty') {
        this.$el.hide();
        return;
    }

    // If something from the old school handle selection was made
    // this could be Collaborators, Products list, Dashboard, Production
    // Logs, Debug...
    if (selection.type === 'app') {
        this.$el.show();
        show_account_dropdown(this);
        // If we were in a product view,
        if (this.getRegion('product') && this.getRegion('product').currentView) {
            this.getRegion('product').reset();
            this.getRegion('devicegroup').reset();
            this.$el.find('.breadcrumb-pointer').hide();
        }

        // If we were in an account view,
        if (this.getRegion('account') && this.getRegion('account').currentView) {
            this.getRegion('account').reset();
            this.getRegion('product').reset();
            this.getRegion('devicegroup').reset();
            this.$el.find('.breadcrumb-pointer').hide();
            show_account_dropdown(this);
        }
    }
    var self = this;
    if ( selection.v5_object ){
        this.getRegion('account').reset();
        this.getRegion('product').reset();
        this.getRegion('devicegroup').reset();
        this.$el.find('.breadcrumb-pointer').hide();
        let owner;
        owner = selection.v5_object.rel && selection.v5_object.rel.get('owner');
        show_account_dropdown(this, owner);

        selection.v5_object.fetch()
        .then( function(){
            if ( selection.v5_object.type && selection.v5_object.type.indexOf('devicegroup') > -1) {
                selection.v5_object.rel.get('product').fetch().then(
                    function() {
                        create_breadcrumbs(selection, self);
                    }
                );
            } else {
                create_breadcrumbs(selection, self);
            }
        });
    }
}

function create_breadcrumbs(selection, self) {
    var product;
    var workspace;
    var devicegroup;
    if (selection.type) {
        if (selection.type === 'device') {
            self.getRegion('account').reset();
            self.getRegion('product').reset();
            self.getRegion('devicegroup').reset();
            self.$el.hide();
            return;
        }
        if (selection.type === 'product') {
            self.$el.show();
            if (self.getRegion('devicegroup') && self.getRegion('devicegroup').currentView) {
                self.getRegion('devicegroup').reset();
                self.$el.find('.breadcrumb-pointer').hide();
            }
            product = selection.v5_object;
            if (!product) { return; }

            return show_product_dropdown(self, product, selection.area);
        }
    
        if (selection.type === 'factory') {
            self.$el.show();
            if (self.getRegion('devicegroup') && self.getRegion('devicegroup').currentView) {
                self.getRegion('devicegroup').reset();
                self.$el.find('.breadcrumb-pointer').hide();
            }
            product = selection.v5_object;
            if (!product) { return; }
            return show_factory_dropdown(self, product, selection.area );
        }
        if (selection.type === 'dut') {
            self.$el.show();
            if (self.getRegion('devicegroup') && self.getRegion('devicegroup').currentView) {
                self.getRegion('devicegroup').reset();
                self.$el.find('.breadcrumb-pointer').hide();
            }
            product = selection.v5_object;
            if (!product) { return; }
            return show_dut_dropdown(self, product, selection.area );
        }
    }

    switch ( selection.v5_object.type ) {
        case 'development_devicegroup' :
            self.$el.show();
            workspace = selection.v5_object;
            product = workspace.rel.get('product');
            if ( !product || !workspace ) { return; }
            return show_development_devicegroup_dropdown(self, product, workspace);
        case 'pre_factoryfixture_devicegroup' :
            self.$el.show();
            workspace = selection.v5_object;
            product = workspace.rel.get('product');
            if ( !product || !workspace ) { return; }
            return show_pre_factoryfixture_devicegroup_dropdown(self, product, workspace);
        case 'pre_dut_devicegroup' :
            self.$el.show();
            workspace = selection.v5_object;
            product = workspace.rel.get('product');
            if ( !product || !workspace ) { return; }
            return show_pre_dut_devicegroup_dropdown(self, product, workspace);
        case 'pre_production_devicegroup':
            self.$el.show();
            workspace = selection.v5_object;
            product = workspace.rel.get('product');
            if ( !product || !workspace ) { return; }
            return show_pre_production_devicegroup_dropdown(self, product, workspace);
        case 'production_devicegroup':
            self.$el.show();
            devicegroup = selection.v5_object;
            product = devicegroup.rel.get('product');
            if ( !product || !devicegroup ) { return; }
            return show_devicegroup_dropdown(self, product, devicegroup);
        case 'factoryfixture_devicegroup':
            self.$el.show();
            devicegroup = selection.v5_object;
            product = devicegroup.rel.get('product');
            if ( !product || !devicegroup ) { return; }
            return show_factoryfixture_dropdown(self, product, devicegroup);
        case 'dut_devicegroup' :
            self.$el.show();
            workspace = selection.v5_object;
            product = workspace.rel.get('product');
            if ( !product || !workspace ) { return; }
            return show_dut_devicegroup_dropdown(self, product, workspace);
    }
}

var BreadcrumbNavLayout = Marionette.View.extend({
    className: 'ei-breadcrumb-nav',
    regions: {
        account: '.breadcrumb-account',
        product: '.breadcrumb-product',
        devicegroup: '.breadcrumb-devicegroup'
    },
    initialize: function(){
        globalCh.on('selection', handle_selection.bind(this));
    },
    onRender: function(){
        show_account_dropdown(this);
        // Listen to ajax_start and ajax_stop events to set the progress 
        // indicator
        apiCh.on('ajax_start', function() {
            this.$('.network-status').addClass('loading');
        }.bind(this));
        apiCh.on('ajax_stop', function() {
            this.$('.network-status').removeClass('loading');
        }.bind(this));             
    },
    template: Handlebars.compile(template),
});
export default BreadcrumbNavLayout;
